import { z } from 'zod';

export const LedgerAccount = z.enum([
  '未収立替金',
  '立替金',
  '売掛金',
  '請求在庫',
  '立替金',
  '未払立替金',
  '支払在庫',
  '買掛金',
]);

export type LedgerAccount = z.infer<typeof LedgerAccount>;
